import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { DropdownFilter, TableColumn } from 'src/app/components/table';
import { ShopProductGroupService } from 'src/app/connect-api/api/shop/shop-product-group.service';

@Component({
  selector: 'app-shop-groups',
  templateUrl: './shop-groups.component.html',
  styleUrl: './shop-groups.component.scss'
})
export class ShopGroupsComponent implements OnInit {
  private title = inject(Title);
  private permissionsService = inject(NgxPermissionsService);
  protected shopProductGroupService = inject(ShopProductGroupService);
  permission: boolean = true;

  cols = [
    new TableColumn('Id', 'id', true, 'text', 'group/', 'id', true, 'equals'),
    new TableColumn(
      'Nome',
      'name',
      true,
      'text',
      'group/',
      'id',
      true,
      'contains'
    ),
    new TableColumn(
      'Markup Min',
      'markupMin',
      true,
      'number',
      undefined,
      undefined,
      undefined,
      'equals'
    ),
    new TableColumn.Builder()
      .setHeader('Subscriber Discount')
      .setField('subscriberDiscountPercentage')
      .setFilter(true)
      .setType('number')
      .setShowMobile(true)
      .setCondition('equals')
      .setDisplayFunction((item) => `${item.subscriberDiscountPercentage}%`)
      .build(),
    new TableColumn(
      'Precificação Dinâmica',
      'dynamicPrecification',
      true,
      'boolean',
      undefined,
      undefined,
      undefined,
      'equals'
    )
  ];

  dropdownFilters: {
    [field: string]: Array<DropdownFilter>;
  } = {
    dynamicPrecification: [
      { label: 'Todos', value: undefined },
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  };

  async ngOnInit(): Promise<void> {
    this.title.setTitle('Loja - Grupo de Produtos');

    // this.permission = await this.permissionsService.hasPermission([
    //   roleAsObject(Role.Full_Administrator).enumValue,
    //   roleAsObject(Role.Portfolio).enumValue
    // ]);
  }
}
